module.exports = __webpack_public_path__ + "static/media/RCP Privacy Policy New.fca904db.pdf";